import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";

export default function Faq({ content }) {
  const faqs = content.faqs || [];
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;

  return (
    <section id="faq" className="scroll-mt-20 py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1fr_1.5fr] gap-14 lg:gap-20">
        <div>
          <SectionHead overline="FAQ" title="Common questions, straight answers" />
          <Reveal delay={0.1}>
            <p className="mt-6 text-sm sm:text-base text-gray-400 leading-relaxed max-w-sm">
              Everything drivers usually ask before booking a remap. Something else on your mind? Send us an enquiry and we'll give you an honest answer.
            </p>
          </Reveal>
        </div>
        <div>
          {faqs.map((f, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div className="border-t border-white/10 last:border-b">
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  data-testid={`faq-question-${i}`}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <span className="flex items-baseline gap-5">
                    <span className="font-display text-sm font-semibold text-electric-bright shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-lg sm:text-xl font-medium uppercase tracking-tight text-white group-hover:text-electric-bright transition-colors">
                      {f.q}
                    </span>
                  </span>
                  <motion.span
                    animate={{ rotate: open === i ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`shrink-0 transition-colors ${open === i ? "text-electric-bright" : "text-gray-500"}`}
                  >
                    <Plus size={18} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 sm:pl-12 text-sm sm:text-base text-gray-400 leading-relaxed max-w-2xl" data-testid={`faq-answer-${i}`}>
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
